import { useMemo } from "react";
import { useNavigation, redirect } from "react-router-dom";
import { ProfileForm, SecurityForm } from "@/components/settings/SettingsForms";
import { queryClient } from "@/lib/queryClient";
import { cn } from "@/lib/utils";
import {
  fetchSettingsProfile,
  SETTINGS_PROFILE_QUERY_KEY,
  SETTINGS_STALE_TIME,
  useSettingsProfile,
} from "@/hooks/useSettingsData";

// Personal account: profile + security of the signed-in user. Moved off
// /settings (now the admin area) to /account, reached from the avatar menu.
export async function accountLoader() {
  try {
    await queryClient.prefetchQuery({
      queryKey: SETTINGS_PROFILE_QUERY_KEY,
      queryFn: fetchSettingsProfile,
      staleTime: SETTINGS_STALE_TIME,
    });

    return null;
  } catch {
    return redirect("/login");
  }
}

export default function AccountPage() {
  const navigation = useNavigation();
  const { data: profile, isPending } = useSettingsProfile();

  const fullName = useMemo(
    () => (profile ? `${profile.firstName} ${profile.lastName}`.trim() : ""),
    [profile],
  );

  const isRouteLoading = navigation.state === "loading";
  const isLoadingData = isRouteLoading || isPending;

  if (!profile) {
    return null;
  }

  return (
    <div
      className={cn(
        "max-w-4xl space-y-8 p-8 transition-opacity",
        isLoadingData && "opacity-50 pointer-events-none",
      )}
    >
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Account</h1>
        <p className="text-muted-foreground">
          Manage your profile and security preferences. Welcome back, {fullName}
          .
        </p>
      </div>

      <div className="grid gap-8 md:grid-cols-2">
        <ProfileForm profile={profile} />
        <SecurityForm />
      </div>
    </div>
  );
}
